import { Layers } from "appworks/graphics/layers/layers";
import { MatrixSkipAreaControl } from "appworks/ui/controls/standard/shape/matrix-skip-area-control";
import { ControlFactory } from "../control-factory";

/**
 * No graphic required, but when the Skip/skip scene is active, this will create a control which will automatically make a shape matching the matrix bounds to be used as a skipArea
 */
export class MatrixSkipAreaControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer === Layers.get("Skip") && layer.currentSceneIs("skip")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        return [new MatrixSkipAreaControl()];
    }
}
